import {Actions, createEffect, ofType} from "@ngrx/effects";
import {catchError, map, mergeMap} from "rxjs/operators";
import {of} from "rxjs";
import {ProviderConnectivityActions} from "@gnv-store";
import {MonitoringRepo} from "src/app/repositories/monitoring-repo";
import {TableProviderMonitoringList} from "src/app/mapper/table/table-provider-monitoring-list";
import {ExternalApiMonitoring} from 'src/swagger-gen/web-secured/models/external-api-monitoring';
import {inject} from '@angular/core';

export class ProviderConnectivityEffect {
  private readonly actions$ = inject(Actions);
  private readonly monitoringRepo = inject(MonitoringRepo);
  private readonly tableProviderMonitoringList = inject(TableProviderMonitoringList);


  fetchData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProviderConnectivityActions.searchAll),
      mergeMap(() => this.monitoringRepo.getProviderConnectivities({ limit: 100, offset: 0 })), // Because there will never be more than 100
      map(response => this.tableProviderMonitoringList.init(response.list as ExternalApiMonitoring[])),
      map(data => ProviderConnectivityActions.fetchSuccess({ data })),
      catchError(error => of(ProviderConnectivityActions.fetchFailure({ message: error?.toString() })))
    );
  });
}
